import { render, staticRenderFns } from "./SelectPolicy.vue?vue&type=template&id=54567944"
import script from "./SelectPolicy.vue?vue&type=script&lang=js"
export * from "./SelectPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports